<div class="box-content rd-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetGeneralPricingAssumptions" class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
      </tr>
    </thead>
    <tbody *ngIf="widgetData">
      <tr class="light-grey-line">
        <td colspan="11">
          <widget-label [widget]="this" [fieldName]="'exitCapRate'" [align]="'left'" [bold]="true"></widget-label>
        </td>
        <td colspan="11">
          <widget-value [align]="'right'" [bold]="true">{{(widgetData.exitCapRate || 0) * 100 | rdLocalizedNumber:2}}%</widget-value>
        </td>
      </tr>
      <tr>
        <td colspan="11">
          <widget-label [widget]="this" [fieldName]="'discountRate'" [align]="'left'" [bold]="true"></widget-label>
        </td>
        <td colspan="11">
          <widget-value [align]="'right'" [bold]="true">{{(widgetData.discountRate || 0) * 100 | rdLocalizedNumber:2}}%</widget-value>
        </td>
      </tr>
    </tbody>
  </table>
</div>
